import React from "react";
import { FaFacebookF, FaYoutube } from "react-icons/fa";
import { RiMessengerFill } from "react-icons/ri";
import { AiOutlineTwitter, AiOutlineInstagram } from "react-icons/ai";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import "../css/footercss.css";
import { productData } from "../rawData/MenuData";
// import { Typography } from "@mui/material";

const Footer = () => {
  return (
    <>
      <section className="Contact-backcolor pt-5  border-top border-bottom">
        <div className="container pt-3 pb-3">
          <div className="row">
            <div className="col-12 col-sm-12 col-md-6 col-lg-6">
              <div className=" d-flex text-center wrapper">
                <div className="button">
                  <div className="icon">
                    <FaFacebookF className="i" />
                  </div>
                  <span>Facebook</span>
                </div>
                <div className="button">
                  <div className="icon">
                    <AiOutlineTwitter className="i" />
                  </div>
                  <span>Twitter</span>
                </div>
                <div className="button">
                  <div className="icon">
                    <AiOutlineInstagram className="i" />
                  </div>
                  <span>Instagram</span>
                </div>
                <div className="button">
                  <div className="icon">
                    <RiMessengerFill className="i" />
                  </div>
                  <span>Messenger</span>
                </div>
                <div className="button">
                  <div className="icon">
                    <FaYoutube className="i" />
                  </div>
                  <span>Youtube</span>
                </div>
              </div>
            </div>

            <div className="col-12 col-sm-12 col-md-6 col-lg-6">
              <div className="subcribe">
                <a className="subAnchor">Subcribe to our newsletter</a>
                <div className="payment mt-2">
                  <a>Payment Method</a>
                  <ul>
                    <li className="mada">media</li>
                    <li className="visa">med</li>
                    <li className="master">med</li>
                    <li className="apple">med</li>
                    <li className="paypal">medi</li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="col-12 col-sm-12 col-md-12 col-lg-12">
              <nav class="nav nav-pills flex-column flex-sm-row border-top border-bottom mt-3">
                <a class="flex-sm-fill text-sm-center nav-link ">
                  Active
                  <div className="BackMenu">
                    <ul class="list-group p-2">
                      {productData.map(({ item }) => (
                        <li class="list-group-item">{item}</li>
                      ))}
                    </ul>
                  </div>
                </a>
                <a class="flex-sm-fill text-sm-center nav-link">
                  Longer nav link
                  <div className="BackMenu">
                    <ul class="list-group p-2">
                      {productData.map(({ item }) => (
                        <li class="list-group-item">{item}</li>
                      ))}
                    </ul>
                  </div>
                </a>
                <a class="flex-sm-fill text-sm-center nav-link">
                  Link
                  <div className="BackMenu">
                    <ul class="list-group p-2">
                      {productData.map(({ item }) => (
                        <li class="list-group-item">{item}</li>
                      ))}
                    </ul>
                  </div>
                </a>
                <a class="flex-sm-fill text-sm-center nav-link">
                  Link{" "}
                  <div className="BackMenu">
                    <ul class="list-group p-2">
                      {productData.map(({ item }) => (
                        <li class="list-group-item">{item}</li>
                      ))}
                    </ul>
                  </div>
                </a>
                <a class="flex-sm-fill text-sm-center nav-link ">
                  Link{" "}
                  <div className="BackMenu">
                    <ul class="list-group p-2">
                      {productData.map(({ item }) => (
                        <li class="list-group-item">{item}</li>
                      ))}
                    </ul>
                  </div>
                </a>
              </nav>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Footer;
